<ng-template [ngIf]="gatewayProvider" [ngIfElse]="loading">
  <div *ngIf="gatewayProvider" class="search-container">
    <visual-filter
      [terms]="searchTerms"
      [clearSearch]="clearSearchSubject.asObservable()"
      (filterChanged)="setSearchParameters($event)"
      (enterPressed)="doSearch()"
    ></visual-filter>
    <div class="buttons">
      <button class="clear" (click)="clearSearchClicked()">clear</button>
      <button class="search" (click)="doSearch()">search</button>
    </div>
  </div>
  <div class="search-results">
    <evrideo-ag-grid-evrideo-header [selectedCount]="selectedTableItemsCount">
      <div
        class="import-button"
        (click)="importButtonClicked()"
        [class.active]="selectedTableItemsCount > 0"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.83333 17C4.3731 17 4 16.6269 4 16.1667C4 15.7064 4.3731 15.3333 4.83333 15.3333H14.8333C15.2936 15.3333 15.6667 15.7064 15.6667 16.1667C15.6667 16.6269 15.2936 17 14.8333 17H4.83333ZM7.49951 3.20016C7.49951 3.08971 7.58905 3.00016 7.69951 3.00016H12.2995C12.41 3.00016 12.4995 3.08971 12.4995 3.20016V8.00016H15.35C15.5282 8.00016 15.6174 8.21559 15.4914 8.34158L10.1409 13.6921C10.0628 13.7702 9.93619 13.7702 9.85809 13.6921L4.5076 8.34158C4.3816 8.21559 4.47084 8.00016 4.64902 8.00016H7.49951V3.20016ZM9.9999 11.4751L11.8082 9.66676H10.8332V4.66677H9.16657V9.66676H8.19157L9.9999 11.4751Z"
            fill="black"
            fill-opacity="0.35"
          />
        </svg>
        <span>import</span>
      </div>
      <div class="customize-button" (click)="toggleCustomizeTable()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M15.625 2.5H4.375C3.34094 2.5 2.5 3.34094 2.5 4.375V15.625C2.5 16.6591 3.34094 17.5 4.375 17.5H15.625C16.6591 17.5 17.5 16.6591 17.5 15.625V4.375C17.5 3.34094 16.6591 2.5 15.625 2.5ZM11.875 3.75V16.25H8.125V3.75H11.875ZM3.75 15.625V4.375C3.75 4.03031 4.03031 3.75 4.375 3.75H6.875V16.25H4.375C4.03031 16.25 3.75 15.9697 3.75 15.625ZM16.25 15.625C16.25 15.9697 15.9697 16.25 15.625 16.25H13.125V3.75H15.625C15.9697 3.75 16.25 4.03031 16.25 4.375V15.625Z"
            fill="black"
            fill-opacity="0.54"
          />
        </svg>
        <span> customize table </span>
      </div>
      <ng-template [ngIf]="showCustomizeTable">
        <external-mam-customize-table
          [columns]="columnsForCostumization"
          (onExit)="onCustomizeTableExit($event)"
        ></external-mam-customize-table>
      </ng-template>
    </evrideo-ag-grid-evrideo-header>
    <ag-grid-angular
      #searchResultsGrid
      class="ag-theme-balham ag-theme-evrideo"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
      [gridOptions]="gridOptions"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
    ></ag-grid-angular>
    <ag-grid-evrideo-footer
      [selectedPageSize]="pageSize"
      [gridApi]="gridApi"
      (goToPageClicked)="goToPage($event)"
      (pageSizeChanged)="setPageSize($event)"
      [isInfinite]="true"
    >
    </ag-grid-evrideo-footer>
  </div>
</ng-template>

<ng-template #loading> </ng-template>
